NOT FOUND
<!-- 
<div class="cover-photo" style="position: relative; z-index: 3; left: 0; right: 0; height: 200px"></div>

<div class="extra-light-grey-cfa-languedoc-bg" style="position: relative; z-index: 10;">
    <div class="container px-3 pb-3 white-bg">
        <h1 style="font-size: 30px" class="text-center pt-5 pb-3">Page introuvable</h1>
        <div class="cfa-languedoc-paragraphe">
            <h5>Centre de Formation du Languedoc</h5>
            <br>
            <p>
                Il semble que la page recherchée n'existe pas ou plus.<br><br>
                Veuillez retourner sur la page d'accueil afin de parcourir à nouveau le site du Centre de Formation du Languedoc svp.   
            </p>

            <div class="col-12 px-0 text-center my-5">
                <a class="bouton-cfa-languedoc col-12 col-md-10 col-lg-8" routerLink="/" href="/">Retour à l'accueil</a>
            </div>
        </div>
    </div>
</div> -->